@if (mappingRulesFormGroup) {
  <form [formGroup]="mappingRulesFormGroup">
    <div class="flex">
      <div class="property-box-wrapper">
        @if (showFixedDestination$ | async) {
          <div class="property-box">
            {{ attributeControl.value }}
          </div>
        } @else {
          @if (showCustomInput) {
            <em-input
              [label]="'SHARED_LABEL_DESTINATION_ATTRIBUTE' | translate"
              [subscriptSizing]="'dynamic'"
              formControlName="attribute"
              [matTooltip]="attributeControl.value"
              [matTooltipShowDelay]="500"
            >
              <em-error>
                @if (attributeControl?.hasError('required')) {
                  {{ 'VALIDATION_FIELD_REQUIRED' | translate }}
                }
                @if (
                  !attributeControl?.hasError('unique') &&
                  attributeControl?.hasError('nonCustomExist')
                ) {
                  {{ 'MAPPING_ENGINE_ATTR_CUSTOM_EXIST_MESSAGE' | translate }}
                  @if (attributeControl?.hasError('nonCustomExist')) {
                    <div>
                      <a
                        (click)="convertToNonCustom()"
                        class="flex items-center"
                      >
                        <em-icon name="loop" class="mr-1"></em-icon>
                        <span
                          >{{
                            'MAPPING_ENGINE_CONVERT_TO_NON_CUSTOM' | translate
                          }}
                        </span>
                      </a>
                    </div>
                  }
                }
                @if (attributeControl?.hasError('unique')) {
                  {{ 'MAPPING_ENGINE_ATTR_UNIQUE_MESSAGE' | translate }}
                }
              </em-error>
            </em-input>
          } @else {
            <em-select
              [label]="'SHARED_LABEL_DESTINATION_ATTRIBUTE' | translate"
              [subscriptSizing]="'dynamic'"
              formControlName="attribute"
              [matTooltip]="attributeControl.value"
              [matTooltipShowDelay]="500"
            >
              @for (
                attribute of availableAttributes$ | async;
                track attribute
              ) {
                <em-option [value]="attribute"> {{ attribute }}</em-option>
              }
              <em-error>
                @if (attributeControl?.hasError('required')) {
                  {{ 'VALIDATION_FIELD_REQUIRED' | translate }}
                }
                @if (attributeControl?.hasError('unique')) {
                  {{ 'MAPPING_ENGINE_ATTR_UNIQUE_MESSAGE' | translate }}
                }
              </em-error>
            </em-select>
          }
        }
      </div>
      <div class="flex-grow" formArrayName="mappingRules">
        @for (
          mappinRule of mappingRulesFormArray.controls;
          track mappinRule;
          let index = $index
        ) {
          <div [ngClass]="{'pt-5 border-t border-gray-300 mt-4': index > 0}">
            @if (
              index === mappingRulesFormArray.controls.length - 1 && index !== 0
            ) {
              <div class="otherwise-label">
                {{ 'SHARED_LABEL_OTHERWISE' | translate }}:
              </div>
            }
            <em-mapping-rule
              class="block flex-auto"
              [formGroup]="mappinRule"
              [availableAttributes]="sourceAttributes"
              [customAttributes]="customSourceAttributes"
              [operatorGroups]="operatorGroups"
              [allowDelete]="
                index !== mappingRulesFormArray.controls.length - 1 &&
                mappingRulesFormArray.controls.length > 2
              "
              [allowCondition]="
                index === 0 ||
                index !== mappingRulesFormArray.controls.length - 1
              "
              [allowClearAllConditions]="
                index !== mappingRulesFormArray.controls.length - 1 &&
                mappingRulesFormArray.controls.length === 2
              "
              (delete)="removeRule(index)"
            >
            </em-mapping-rule>
            <!-- Show add new rule before the last rule -->
            @if (
              mappingRulesFormArray.controls.length > 1 &&
              index === mappingRulesFormArray.controls.length - 2
            ) {
              <div class="pt-5 border-t border-gray-300 mt-4">
                <div class="add-rule-wrapper">
                  <em-button (btnClick)="addNewRule()"
                    >+ {{ 'SHARED_LABEL_ADD_MAPPING_RULE' | translate }}
                  </em-button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <div class="mt-6" [@expandCollapse]>
      <em-box size="sm" [title]="'SHARED_LABEL_MAPPING_SETTINGS' | translate">
        <em-checkbox [formControl]="stripHtmlControl">{{
          'SHARED_LABEL_STRIP_HTML' | translate
        }}</em-checkbox>
      </em-box>
    </div>
  </form>
}
